import { FC, MutableRefObject } from 'react';

import { Bonus } from '../../../../../../types/bonus';
import { BonusContent } from '../../bonus/bonus-content';

interface BonusModalContentProps {
	bonus: Bonus;
	commentsDefaultOpen?: boolean;
	commentBoxRef: MutableRefObject<HTMLDivElement | null>;
}
export const BonusModalContent: FC<BonusModalContentProps> = ({ bonus, commentsDefaultOpen = true, commentBoxRef }) => {
	return <BonusContent bonus={bonus} shouldCommentBeOpenedInModal={commentsDefaultOpen} commentBoxRef={commentBoxRef} />;
};
